module.exports = __webpack_public_path__ + "assets/img/120305.29715aa0.svg";